/* eslint-disable import/prefer-default-export */
import { SET_DATE_RANGE } from "./actionTypes";
import { buildErrorMessage } from "../../../apis/calls";

export const setDateRange = (startDate, endDate) => async (dispatch) => {
  try {
    dispatch({
      type: SET_DATE_RANGE,
      payload: { startDate, endDate },
    });
  } catch (error) {
    console.error(buildErrorMessage(error));
  }
}
